export default class PushStateNavigationEngine {
  constructor ({
    getUrlFromState = JSON.stringify,
    getStateFromUrl = JSON.parse,
    historyApi = window.history,
    onPopState = listener => window.addEventListener('popstate', ({state}) => listener(state)),
    getCurrentUrl = () => window.location.pathname + window.location.search + window.location.hash,
    initialState = null,
  }) {
    this.getUrlFromState = getUrlFromState;
    this.getStateFromUrl = getStateFromUrl;
    this.historyApi = historyApi;
    this.getCurrentUrl = getCurrentUrl;
    this.initialState = initialState;
    this._didInitialize = false;
    this._urlPrefix = '';
    this._returnToHandler = null;
    onPopState(state => {
      //console.log('POPSTATE EVENT', state);
      if (!state) {
        state = this.getStateFromUrl(this.getCurrentUrl().slice(this._urlPrefix.length));
      }
      this._didInitialize = true;
      this._returnToHandler(state);
    });
  }

  addNewNavState (newState) {
    this.historyApi.pushState(newState, null, this._urlPrefix + this.getUrlFromState(newState));
  }

  replaceCurrentNavState (newState) {
    this.historyApi.replaceState(newState, null, this._urlPrefix + this.getUrlFromState(newState));
  }

  onReturnToState (eventListener) {
    if (this._returnToHandler) {
      throw new Error('There should only be one way to handle resuming an application state.');
    }
    this._returnToHandler = eventListener;
    if (!this._didInitialize) {
      let state = this.historyApi.state || this.initialState;
      if (!state) {
        state = this.getStateFromUrl(this.getCurrentUrl());
      }
      let stateUrl = this.getUrlFromState(state);
      if (this.getCurrentUrl().endsWith(stateUrl)
          || this.getCurrentUrl().split('#')[0].endsWith(stateUrl)) {
        this._urlPrefix = this.getCurrentUrl().slice(0, -stateUrl.length);
      } else {
        console.warn(`WARNING: Initial state url ${stateUrl} is not at the end of the actual page url: ${this.getCurrentUrl()}!`);
      }
      this._didInitialize = true;
      this.replaceCurrentNavState(state);
      return this._returnToHandler(state);
    }
  }

  returnToState (offset) {
    this.historyApi.go(offset);
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-router/PushStateNavigationEngine.js